
import '../../../styles/Auth/viewComboOffer.css';
export default function ComboOfferDetailsPopup({ isOpen, onClose, comboOfferData }) {
    if (!isOpen || !comboOfferData) return null;

    const offer = comboOfferData?.data || comboOfferData;

    return (
        <div className="combo-offer-popup-overlay">
            <div className="combo-offer-popup-container">
                {/* Header */}
                <div className="combo-offer-popup-header">
                    <h2>Combo Offer Details</h2>
                </div>

                {/* Product Details */}
                <div className="combo-offer-popup-section">
                    <h3>Products in Offer</h3>
                    {offer.productIds?.length > 0 ? (
                        <div className="table-wrapper">
                            <table className="products-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Product Name</th>
                                        <th>Product Code</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {offer.productIds.map((prod, index) => (
                                        <tr key={prod._id || index}>
                                            <td>{index + 1}</td>
                                            <td>{prod.title}</td>
                                            <td>{prod.productCode}</td>
                                            <td>₹{prod.sellingPrice}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="no-products">No products found in this offer.</p>
                    )}
                </div>

                {/* Footer */}
                <div className="combo-offer-popup-footer">
                    <button className="btn-close" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
}
